import { Props } from '@procore/core-react/dist/_typedoc/_utils/types.json';
import { ContactItemProps } from '@procore/core-react/dist/_typedoc/ContactItem/ContactItem.types.json';
import * as React from 'react';
export default {
  Props,
  ContactItemProps,
  React
};